import { styled, StyledButton } from '@raskrask-dk/rr-components'

export const ButtonWrapper = styled('div', {
    [`& ${StyledButton}`]: {
        w: '100%',
    },

    '@mobile': {
        background:
            'linear-gradient(to top, $white 65%, rgba(255, 255, 255, 0) 100%)',
        bottom: 0,
        left: 0,
        p: 16,
        pt: 48,
        pointerEvents: 'none',
        position: 'fixed',
        right: 0,
        zIndex: '$fixed',

        [`& ${StyledButton}`]: {
            pointerEvents: 'auto',
        },
    },
})
